import React from "react";
import Cookies from "universal-cookie";
import logo from "../../images/Logo.svg";
import { logout } from "../login/SesionService";
import AdminNav from "./AdminNav";

function AdminLayout({ tituloSeccion, children }) {
  const cookies = new Cookies();
  const nombreAdmin = cookies.get("username");

  const handleLogout = () => {
    logout();
  };

  return (
    <div className="template-base admin-layout">
      <header className="admin-header">
        <div className="page-container admin-header__inner">
          <img
            src={logo}
            className="admin-header__logo"
            alt="Logotipo MiRecibo"
          />
          <span className="admin-header__titulo">{tituloSeccion}</span>
          <div className="admin-header__user">
            <span className="admin-header__nombre">{nombreAdmin}</span>
            <button className="admin-header__logout" onClick={handleLogout}>
              <span className="material-symbols-outlined">logout</span>
              Cerrar sesión
            </button>
          </div>
        </div>
      </header>
      <AdminNav />
      <main>{children}</main>
    </div>
  );
}

export default AdminLayout;
